module.exports = __webpack_public_path__ + "static/img/serviceQRCode.403454a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/serviceQRCode.jpg
// module id = bP5H
// module chunks = 26